import { Group, Text } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { IconSearch } from "@tabler/icons-react"
import { TextInput, Button } from "@tfg/ui"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { ClientFilter } from "~/pages/SupplierPortal/TraceabilityRequests/components/ClientFilter"
import { TypesFilter } from "~/pages/SupplierPortal/TraceabilityRequests/components/TypesFilter"

interface RequestFiltersProps {
  sorts: {
    value: string | null
    iconNext: JSX.Element
    name: string
    toggle: () => void
    hide?: boolean
  }[]
  filters: getTraceabilityRequestsQueryParams["filters"]
  setFilters: Dispatch<
    SetStateAction<getTraceabilityRequestsQueryParams["filters"]>
  >
}

export const RequestFilters = ({
  filters,
  setFilters,
  sorts,
}: RequestFiltersProps) => {
  const { t } = useTranslation(["traceability"])

  const [search, setSearch] = useState<string | undefined>(filters?.search)
  const [debouncedSearch] = useDebouncedValue<string | undefined>(search, 600)
  useEffect(() => {
    setFilters((prev) => ({ ...prev, search: debouncedSearch }))
  }, [debouncedSearch, setFilters])

  return (
    <Group gap="xs">
      <TextInput
        value={search}
        autoFocus
        w={180}
        size="xs"
        onChange={(e) => setSearch(e.target.value)}
        leftSection={<IconSearch size={16} />}
        placeholder={t("filters.search")}
      />
      <TypesFilter
        filtersValue={filters}
        setFiltersValue={(val) => setFilters(val)}
      />
      <ClientFilter
        filtersValue={filters}
        setFiltersValue={(val) => setFilters(val)}
      />

      {sorts.map(
        (sort) =>
          !sort.hide && (
            <Button
              key={sort.name}
              icon={sort.iconNext}
              variant="tertiary"
              onClick={sort.toggle}
              maw={180}
              size="xs"
            >
              <Text>{sort.name}</Text>
            </Button>
          )
      )}
    </Group>
  )
}
